"use client";

import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

const Cta = () => {
  return (
    <>
      <div className="unlock-area ptb-150 position-relative z-1" id="admin">
        <Container>
          <div className="border-bottom pb-150">
            <Row>
              <div className="unlock-content">
                <h2>گسترش جامعه مشتریان با حساب اعتبار</h2>
                <p>
                  فروشگاه های معتبر می توانند با اتصال به حساب اعتبار تعاونی فرهنگیان بویین و میاندشت جامعه مشتریان خود را گسترش و پرداخت مشتریان را تسهیل کنند.
                </p>

                <Link
                  to="tel:+983157522269"
                  className="btn btn-primary-div py-2 px-4 fs-16 fw-medium rounded-3 text-white"
                >
                  <div className="d-flex align-items-center gap-1">
                    <i className="ri-phone-line fs-18"></i>
                    <span>تماس با ما - 03157522269</span>
                  </div>
                </Link>
              </div>
            </Row>
          </div>
        </Container>

        <img
          src="/images/landing/shape-1.png"
          className="shape shape-5"
          alt="shape"
          width={1000}
          height={1000}
        />
        <img
          src="/images/landing/shape-2.png"
          className="shape shape-6"
          alt="shape"
          width={947}
          height={953}
        />
      </div>
    </>
  );
};

export default Cta;
